<script setup>
import { useRoute } from 'vue-router'
import { useGA } from '#/useGA'
import { useGlobalStore } from 'src/composables/useGlobalStore'
import EmailSubscribers from 'components/layout/EmailSubscribers.vue'

const route = useRoute()
const { event } = useGA()
const { isLoggedIn } = useGlobalStore()
const navigationEvent = (path, eventLabel) => {
  if (route.fullPath !== path) {
    event('navigation', { eventCategory: 'navigation', eventLabel: eventLabel })
  }
}
</script>

<template lang="pug">
.footer--container(v-if="$route.name !== 'Analyzer'")
  .routerPageSize
    email-subscribers
    .footer--content
      .footer--gif-container
        img.footer--gif(v-lazy="{ src:'/companyLogo.webp' }")
      .footer--links-container
        .footer--link-group
          .footer--link-group-title Navigation
          .footer--links
            router-link.footer--link(to="/" @click="navigationEvent('/', 'B2C Landing Page')") Home
            router-link.footer--link(to="/referenzen" @click="navigationEvent('/referenzen', 'References')") Referenzen
            router-link.footer--link(to="/solutions" @click="navigationEvent('/solutions', 'Solutions')") Lösungen
            router-link.footer--link(to="/glossary" @click="navigationEvent('/glossary', 'Glossary')") Insights
            router-link.footer--link(to="/about-us" @click="navigationEvent('/about-us', 'About Us')") Über uns
        .footer--link-group
          .footer--link-group-title Company
          .footer--links
            router-link.footer--link(to="/impressum" @click="navigationEvent('/impressum', 'Impressum')") Impressum
            router-link.footer--link(to="/terms-and-conditions" @click="navigationEvent('/terms-and-conditions', 'Terms and Conditions')") AGB
            router-link.footer--link(to="/privacy-policy" @click="navigationEvent('/privacy-policy', 'Privacy Policy')") Datenschutz
        .footer--link-group#kontakt
          .footer--link-group-title Kontakt
          .footer--links
            .footer--link Bahnhofstrasse 6
            .footer--link 9000 St. Gallen
            a.footer--link(href="mailto:hallo@raumpioniere.ch" target="_blank") hallo@raumpioniere.ch
            a.footer--link(href="tel:+41715212126" target="_blank") +41 (0)71 521 21 26
            .footer--socials
              a.footer--social(href="https://www.linkedin.com/company/raumpioniere/?originalSubdomain=ch" target="_blank")
                svg.footer--social-svg(width='48' height='48' viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg')
                  path(opacity='0.1' d='M24.0879 47.6922C37.0989 47.6922 47.6465 37.1005 47.6465 24.0351C47.6465 10.9696 37.0989 0.37793 24.0879 0.37793C11.0768 0.37793 0.529297 10.9696 0.529297 24.0351C0.529297 37.1005 11.0768 47.6922 24.0879 47.6922Z' fill='white')
                  path(d='M21.0679 30.835V21.4912H18.1616V30.835H21.0679ZM19.5991 20.2412C20.5366 20.2412 21.2866 19.46 21.2866 18.5225C21.2866 17.6162 20.5366 16.8662 19.5991 16.8662C18.6929 16.8662 17.9429 17.6162 17.9429 18.5225C17.9429 19.46 18.6929 20.2412 19.5991 20.2412ZM31.9116 30.835H31.9429V25.71C31.9429 23.21 31.3804 21.2725 28.4429 21.2725C27.0366 21.2725 26.0991 22.0537 25.6929 22.7725H25.6616V21.4912H22.8804V30.835H25.7866V26.21C25.7866 24.9912 26.0054 23.835 27.5054 23.835C29.0054 23.835 29.0366 25.21 29.0366 26.3037V30.835H31.9116Z' fill='white')
              a.footer--social(href="https://www.youtube.com/channel/UCD0qej8znxRpEZm2m6DShaQ" target="_blank")
                svg(width='48' height='47' viewBox='0 0 48 47' fill='none' xmlns='http://www.w3.org/2000/svg')
                  path(opacity='0.21' fill-rule='evenodd' clip-rule='evenodd' d='M24.3181 0C37.3417 0 47.9164 10.5165 47.9164 23.5C47.9164 36.4835 37.3559 47 24.3181 47C11.2802 47 0.719727 36.4835 0.719727 23.5C0.719727 10.5165 11.2802 0 24.3181 0Z' fill='#979797')
                  path(fill-rule='evenodd' clip-rule='evenodd' d='M34.6473 19.247L34.636 19.2355C34.636 19.2355 34.4326 17.7607 33.7997 17.1204C32.9974 16.2744 32.0933 16.263 31.6864 16.2172C28.7368 16 24.3181 16 24.3181 16H24.3068C24.3068 16 19.8768 16 16.9385 16.2172C16.5316 16.263 15.6276 16.2744 14.8252 17.1204C14.1923 17.7607 13.9889 19.2355 13.9889 19.2355C13.9889 19.2355 13.7742 20.9619 13.7742 22.6883V24.3003C13.7742 26.0267 13.9889 27.753 13.9889 27.753C13.9889 27.753 14.1923 29.2279 14.8252 29.8681C15.6276 30.7142 16.6786 30.6913 17.1532 30.7828C18.8371 30.9428 24.3181 31 24.3181 31C24.3181 31 28.7481 30.9886 31.6977 30.7828C32.1046 30.737 33.0087 30.7256 33.811 29.8796C34.4439 29.2393 34.6473 27.7645 34.6473 27.7645C34.6473 27.7645 34.862 26.0381 34.862 24.3117V22.6997C34.862 20.9733 34.6473 19.247 34.6473 19.247ZM22.1257 26.2668V20.2759L27.8214 23.2828L22.1257 26.2668Z' fill='white')
  .footer-bottom Copyright © 2023, Raumpioniere.ch, All rights reserved.
</template>

<style scoped lang="sass">
.footer--container
  background: #2B3341
  .footer--content
    display: flex
    @media screen and (min-width: 1024px)
      align-items: center
      justify-content: space-between
    @media screen and (max-width: 1024px)
      flex-direction: column-reverse
    .footer--gif-container
      @media screen and (max-width: 1024px)
        width: 100%
        display: flex
        justify-content: center
        margin-top: 60px
      .footer--gif
        width: 200px
        height: 142px
    .footer--links-container
      display: grid
      @media screen and (min-width: 1024px)
        grid-template-columns: 1fr 1fr 1fr
        grid-gap: 70px
      @media screen and (max-width: 1024px)
        grid-template-columns: 1fr
        grid-gap: 30px
      .footer--link-group
        .footer--link-group-title
          font-weight: 700
          line-height: 40px
          color: white
          @media screen and (min-width: 1024px)
            font-size: 22px
            margin-bottom: 10px
          @media screen and (max-width: 1024px)
            font-size: 16px
        .footer--links
          display: flex
          flex-direction: column
          .footer--link
            font-weight: 500
            font-size: 16px
            line-height: 33px
            color: #DFE4EC
            text-decoration: none
          .footer--socials
            display: flex
            grid-gap: 12px
            @media screen and (min-width: 1024px)
              margin-top: 14px
            @media screen and (max-width: 1024px)
              margin-top: 36px
            .footer--social
              cursor: pointer
.footer-bottom
  border-top: 1px solid #FFFFFF
  line-height: 20px
  display: flex
  justify-content: center
  align-items: center
  color: #FFFFFF
  @media screen and (min-width: 1024px)
    margin-top: 25px
    font-size: 16px
    padding: 36px 0
  @media screen and (max-width: 1024px)
    margin-top: 15px
    padding: 20px 0
    font-size: 12px
</style>
